import React from 'react';
export function TacticalLabel({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`font-mono text-sapper-red tracking-[0.2em] text-xs sm:text-sm font-bold uppercase flex items-center gap-2 ${className}`} data-id="element-334">
      <span className="text-sapper-gray opacity-50" data-id="element-335">[</span>
      {children}
      <span className="text-sapper-gray opacity-50" data-id="element-336">]</span>
    </div>;
}